module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/desempeno-icon.0978b8b2.svg";